<script setup>
import { computed, ref, watch } from 'vue'
import companyAvatar from '../assets/company-avatar.png'
import LikeBurstFeedback from './LikeBurstFeedback.vue'
import ViewerIcon from './ViewerIcon.vue'

const props = defineProps({
  open: Boolean,
  meta: {
    type: Object,
    required: true
  }
})

defineEmits(['close', 'like'])

const avatarFailed = ref(false)
const avatarLoaded = ref(false)
watch(() => props.meta.avatar, () => {
  avatarFailed.value = false
  avatarLoaded.value = false
})
const createdAt = computed(() => {
  if (!props.meta.createdAt) return ''
  const date = new Date(props.meta.createdAt)
  if (!Number.isFinite(date.getTime())) return String(props.meta.createdAt)
  const formatted = new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date).replaceAll('/', '.')
  return `更新于 ${formatted}`
})
</script>

<template>
  <section class="sheet sheet--info" :class="{ 'is-open': open }" :aria-hidden="!open">
    <button class="sheet__handle" type="button" aria-label="收起模型信息" @click="$emit('close')">
      <ViewerIcon name="chevron-down" />
    </button>

    <div class="info-sheet__body">
      <header class="info-author">
        <div class="author-avatar">
          <img v-if="!meta.avatar" class="author-avatar__default" :src="companyAvatar" alt="公司默认头像" />
          <span v-else-if="!avatarLoaded && !avatarFailed" class="author-avatar__loading" aria-label="头像加载中"></span>
          <span v-else-if="avatarFailed" class="author-avatar__failed" aria-label="头像加载失败">加载失败</span>
          <img
            v-if="meta.avatar && !avatarFailed"
            class="author-avatar__photo"
            :class="{ 'is-loaded': avatarLoaded }"
            :src="meta.avatar"
            alt="创作者头像"
            @load="avatarLoaded = true"
            @error="avatarLoaded = false; avatarFailed = true"
          />
        </div>
        <div class="author-identity">
          <strong>{{ meta.author }}</strong>
          <small>创作者</small>
        </div>
        <button
          class="info-like"
          :class="{ 'is-liked': meta.isLiked }"
          type="button"
          :aria-label="meta.isLiked ? '取消点赞' : '点赞'"
          :aria-pressed="meta.isLiked"
          @click="$emit('like')"
        >
          <LikeBurstFeedback :active="meta.isLiked"><ViewerIcon name="heart" :filled="meta.isLiked" /></LikeBurstFeedback>
          <span v-if="meta.likes" class="info-like__count">{{ meta.likes }}</span>
        </button>
      </header>

      <div class="info-heading">
        <h2>{{ meta.title }}</h2>
        <p v-if="meta.description">{{ meta.description }}</p>
        <time v-if="createdAt">{{ createdAt }}</time>
      </div>
    </div>
  </section>
</template>
